function usePropValue(propDef, data) {
  if (data == null)
    return data;
  return propDef.fromPropData(data);
}
export {
  usePropValue
};
//# sourceMappingURL=usePropValue.js.map